/* import __COLOCATED_TEMPLATE__ from './ticket-type-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();